module.exports = __webpack_public_path__ + "img/Shared Care.c51daa41.png";